import React from 'react';
import { Box, Text, Flex } from '@chakra-ui/react';

/**
 * DateDivider Component
 * Displays a date divider in chat history (like WeChat)
 *
 * @param {Object} props
 * @param {string} props.date - Date string to display
 */
const DateDivider = ({ date }) => {
  return (
    <Flex
      align="center"
      justify="center"
      my={4}
    >
      <Box flex="1" height="1px" bg="chat.divider" />
      <Box
        px={3}
        py={1}
        bg="gray.100"
        borderRadius="full"
        mx={3}
      >
        <Text
          fontSize="xs"
          color="chat.timestamp"
          fontWeight="medium"
        >
          {date}
        </Text>
      </Box>
      <Box flex="1" height="1px" bg="chat.divider" />
    </Flex>
  );
};

export default DateDivider;
